import apiClient from './apiClient';

export const fsmApi = {
  listFSMs: async (filters = {}) => {
    const params = new URLSearchParams();

    if (filters.limit) {
      params.append('limit', filters.limit);
    }
    if (filters.offset != null) {
      params.append('offset', filters.offset);
    }
    if (filters.status) {
      params.append('status', filters.status);
    }
    if (filters.tags?.length) {
      params.append('tags', filters.tags.join(','));
    }
    if (filters.complexity) {
      params.append('complexity', filters.complexity);
    }

    const response = await apiClient.get(`/fsm?${params.toString()}`);
    return response.data;
  },

  getFSM: async (fsmId) => {
    const response = await apiClient.get(`/fsm/${fsmId}`);
    return response.data;
  },

  createFSM: async (data) => {
    const response = await apiClient.post('/fsm', data);
    return response.data;
  },

  updateFSM: async (fsmId, updates) => {
    const response = await apiClient.put(`/fsm/${fsmId}`, updates);
    return response.data;
  },

  deleteFSM: async (fsmId) => {
    const response = await apiClient.delete(`/fsm/${fsmId}`);
    return response.data;
  },

  // Symbol associations
  addSymbol: async (fsmId, symbol, config) => {
    const response = await apiClient.post(`/fsm/${fsmId}/symbols`, { symbol, ...config });
    return response.data;
  },

  getSymbols: async (fsmId) => {
    const response = await apiClient.get(`/fsm/${fsmId}/symbols`);
    return response.data;
  },

  removeSymbol: async (fsmId, symbol) => {
    const response = await apiClient.delete(`/fsm/${fsmId}/symbols/${encodeURIComponent(symbol)}`);
    return response.data;
  },

  // Instances
  getInstances: async (fsmId) => {
    const response = await apiClient.get(`/fsm/${fsmId}/instances`);
    return response.data;
  },

  getInstance: async (fsmId, symbol) => {
    const response = await apiClient.get(`/fsm/${fsmId}/instances/${encodeURIComponent(symbol)}`);
    return response.data;
  },

  resetInstance: async (fsmId, symbol) => {
    const response = await apiClient.post(`/fsm/${fsmId}/instances/${encodeURIComponent(symbol)}/reset`);
    return response.data;
  },

  compileFSM: async (fsmId) => {
    const response = await apiClient.post(`/fsm/${fsmId}/compile`);
    return response.data;
  },
};

export default fsmApi;
